import { FaDownload } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { CSVDownload } from 'react-csv';
import { saveAs } from 'file-saver';
import { useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import { useAnalytics } from 'use-analytics';
import Button from '../../Button';
import { changeTrip, getTripsCsvRequest } from '../../../store/slices/trip';
import { SearchStatus } from '../../../constants';

const TripsCSVDownloader = () => {
  const { tripsCsv, getTripsCsvStatus } = useSelector((store) => store.trip);
  const { travelAgency = {}, email: loggedInUserEmail } = useSelector((store) => store.user);
  const [csvKey, setCsvKey] = useState(0);
  const dispatch = useDispatch();
  const { track } = useAnalytics();

  const handleClick = () => {
    dispatch(getTripsCsvRequest());
    setCsvKey((c) => c + 1);
    track('DownloadAllAsCSV', { loggedInUserEmail, travelAgencyId: travelAgency.id });
  };

  const doDownloadPlainText = useMemo(() => {
    if (tripsCsv) {
      return typeof tripsCsv === 'string';
    }
    return false;
  }, [tripsCsv]);

  useEffect(() => {
    if (tripsCsv && doDownloadPlainText) {
      const blob = new Blob([tripsCsv], { type: 'text/csv;charset=utf-8' });
      const timeStamp = dayjs().format('YYYY-MM-DD-hh-mm-ss-A');
      saveAs(blob, `TravelWits-bookings-${timeStamp}.csv`);
      dispatch(changeTrip({ field: 'tripsCsv', value: undefined }));
    }
  }, [dispatch, doDownloadPlainText, tripsCsv]);

  return (
    <>
      <Button
        size={Button.buttonSizes.SM}
        variant={Button.buttonVariants.PRIMARY}
        className="ml-2"
        onClick={handleClick}
        doShowLoadingState={getTripsCsvStatus === SearchStatus.SEARCHING}
      >
        <span>
          <FaDownload className="inline-block h-3 mr-2" />
          Download All as CSV
        </span>
      </Button>
      {tripsCsv && !doDownloadPlainText && <CSVDownload data={tripsCsv} key={csvKey} />}
    </>
  );
};

export default TripsCSVDownloader;
